import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

function DamageReporting() {
  return (
    <Box sx={{ p: 4 }}>
      <Paper sx={{ p: 6, textAlign: 'center', borderRadius: 4 }}>
        <WarningAmberIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          Damage Reporting
        </Typography>
        <Typography color="text.secondary">
          This module is currently being optimized for the Restaurant Kitchen workflow. 
          Use the **Consumption** menu for standard stock clearance records.
        </Typography>
      </Paper>
    </Box>
  );
}

export default DamageReporting;
